import type { useToast } from 'braid-design-system';

import type { PageConfig } from 'src/libs/PageConfig';
import type { UseBucketLabelResponse } from 'src/utils/hooks/useBucketLabel';

import getActionConfirmationFromQuery from '../../App/AppPageBlock/utils/getActionConfirmationFromQuery';
import getEasyAccessApplication from '../../App/AppPageBlock/utils/getEasyAccessApplication';
import type { IStore } from '../../stores/Store';

import type { HandleEasyAccessTranslations } from '.';

const handleEasyAccess = (
  store: IStore,
  showToast: ReturnType<typeof useToast>,
  getLabelFromBucket: UseBucketLabelResponse['getLabelFromBucket'],
  messages: HandleEasyAccessTranslations,
  addCustomError: PageConfig['dataDogRum']['addCustomError'],
) => {
  const application = getEasyAccessApplication(store, addCustomError);
  const actionConfirmation = getActionConfirmationFromQuery();

  if (actionConfirmation && application) {
    showToast({
      tone: 'positive',
      message: messages['application has been moved']({
        firstName: application.firstName,
        bucket: getLabelFromBucket(actionConfirmation),
      }),
      closeLabel: messages.close(),
    });
  }
};

export default handleEasyAccess;
